module.exports = __webpack_public_path__ + "img/icon-check-black.141f871b.svg";